import { create } from 'zustand';

interface PresenceState {
  onlineUserIds: Set<string>;
  setOnline: (userId: string) => void;
  setOffline: (userId: string) => void;
  isOnline: (userId: string) => boolean;
  reset: () => void;
}

export const usePresenceStore = create<PresenceState>((set, get) => ({
  onlineUserIds: new Set(),

  setOnline: (userId) =>
    set((s) => {
      const updated = new Set(s.onlineUserIds);
      updated.add(userId);
      return { onlineUserIds: updated };
    }),

  setOffline: (userId) =>
    set((s) => {
      const updated = new Set(s.onlineUserIds);
      updated.delete(userId);
      return { onlineUserIds: updated };
    }),

  isOnline: (userId) => get().onlineUserIds.has(userId),

  reset: () => set({ onlineUserIds: new Set() }),
}));
